import { INPUT_LIMIT_HELP } from './input-limits.js';
import { unsupportedFormatForFile } from './unsupported-format.js';

// Share the same allowlist between the picker and drop/upload validation.
const EXTENSIONS = 'txt text md markdown log json yaml yml csv tsv js jsx mjs cjs ts tsx html htm css scss sass less py rb php java c h cpp hpp cc cs go rs swift kt kts sh bash zsh sql r lua pl vue svelte ini cfg conf toml'.split(' ');
export const UPLOAD_ACCEPT = [...EXTENSIONS, 'parquet'].map((ext) => `.${ext}`).join(',');
// The format list is quoted on its own by the upload control's tooltip, and with
// the byte budget appended by every rejection message — one source for both.
export const UPLOAD_FORMATS_HELP = 'Use JSON, YAML, CSV, TSV, Parquet, plain text (.txt, .md), or a supported code file.';
export const UPLOAD_HELP = UPLOAD_FORMATS_HELP + ' ' + INPUT_LIMIT_HELP;

export function unsupportedUploadFormat(file) {
  const ext = /\.([^.]+)$/.exec(String(file.name || ''))?.[1].toLowerCase();
  if (ext === 'parquet') return null;
  const classified = unsupportedFormatForFile(file);
  // Browsers sometimes assign a generic binary MIME type to valid text files.
  if (EXTENSIONS.includes(ext) && (!classified || classified === 'binary' && (!file.type || file.type.toLowerCase() === 'application/octet-stream'))) return null;
  return classified || 'other';
}

const LABELS = { parquet: 'Parquet', xlsx: 'Spreadsheet', xml: 'XML', pdf: 'PDF', docx: 'Word document', image: 'Image', binary: 'Binary' };
export function unsupportedUploadMessage(kind) {
  return `${LABELS[kind] ? `${LABELS[kind]} files are not supported.` : 'Unsupported file format.'} ${UPLOAD_HELP}`;
}
